var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"settings-template-config"},[_c('templateConfig',{attrs:{"description":_vm.isCluster
        ? '在集群层面，对整期推送、主题推送、专题推送、单篇推送、通知推送以及统一的邮件推送模板进行配置管理。期刊各自的邮件推送模板和推送核心内容由各自管理。'
        : '对整期推送、专题推送、单篇推送、通知推送以及统一的邮件推送模板进行配置管理。',"template-options":_vm.emailTypes},on:{"toDetail":_vm.toDetail}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }